/**
 * @file This file contains the implementation for ZSTD that is used within the browser.
 */
import { decompress as decompressZstd } from 'fzstd';
import { Maybe } from 'purify-ts';
/** @returns `Maybe.empty()` as we can't compress using ZSTD in the browser. */
export function compress() {
    return Maybe.empty();
}
/**
 * Decompress a piece of data that was compressed with ZSTD.
 *
 * @param data The data that should be decompressed.
 * @returns A promise that will resolve to the decompressed data. A promise is resolve to be
 * consistent with `index.ts`.
 */
export async function decompress(data) {
    return decompressZstd(data);
}
